var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgQrCodeIcon = function SvgQrCodeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#qr-code-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M60 89.62c20.553 0 37.215-16.662 37.215-37.215S80.553 15.19 60 15.19 22.785 31.852 22.785 52.405 39.447 89.62 60 89.62"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#E6E6E6",
    d: "M60 89.24c20.344 0 36.835-16.491 36.835-36.835S80.344 15.57 60 15.57 23.165 32.06 23.165 52.405 39.656 89.24 60 89.24Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#qr-code-icon_svg__b)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M53.355 59.05v.014m0-13.304v.013m13.29-.014v.014m0 9.29h-3.987v3.988m7.975-3.988v.014m-7.975 7.961h3.988m0-3.987h3.987v3.987M49.367 43.101a1.33 1.33 0 0 1 1.33-1.329h5.316a1.33 1.33 0 0 1 1.329 1.33v5.316a1.33 1.33 0 0 1-1.33 1.329h-5.316a1.33 1.33 0 0 1-1.329-1.33zm13.291 0a1.33 1.33 0 0 1 1.33-1.329h5.316a1.33 1.33 0 0 1 1.329 1.33v5.316a1.33 1.33 0 0 1-1.33 1.329h-5.316a1.33 1.33 0 0 1-1.329-1.33zm-13.29 13.291a1.33 1.33 0 0 1 1.328-1.329h5.317a1.33 1.33 0 0 1 1.329 1.33v5.316a1.33 1.33 0 0 1-1.33 1.329h-5.316a1.33 1.33 0 0 1-1.329-1.33z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "qr-code-icon_svg__b",
    x1: 70.633,
    x2: 46.283,
    y1: 63.038,
    y2: 46.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15A22"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "qr-code-icon_svg__a",
    width: 104.671,
    height: 104.671,
    x: 7.665,
    y: 5.07,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_158_129"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_158_129",
    result: "shape"
  })))));
};
export default SvgQrCodeIcon;